/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, TemplateRef, viewChild } from '@angular/core';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';

import { BadgeComponent } from '../../../../badge/badge.component';

@Component({
  selector: 'bn-web-ui-multi-label-select-template',
  templateUrl: './multi-label-select-template.component.html',
  imports: [BadgeComponent, FaIconComponent],
})
export class MultiLabelSelectTemplateComponent {
  // Default call this with type
  readonly labelTemplate = viewChild.required<TemplateRef<any>>('labelTemplate');
}
